export const get = () => console.log('TODO');

export const set = () => console.log('TODO');

export const reset = () => console.log('TODO');

export default {
    get,
    set,
    reset
}